import React from "react";
import * as BT from "react-bootstrap-table";
import * as M from "../../models";
import { Utility } from "../../utils";

/**
 * Returns a formatted string from a map record identified by an objects field as its index.
 * @param obj The table row object
 * @param field The field that identifies the map's index
 * @param maps The maps
 * @param mapField The field that will be returned by the index value
 */
export const formatByIndexMap = <T, TMap>(obj: T, field: (t: T) => number | undefined, maps: {[index: number]: TMap}, mapField: (m: TMap) => string): string => {
    const id = field(obj);
    const map = id !== undefined ? maps[id] : undefined;
    return map ? mapField(map) : "";
};

/**
 * Returns a formatted string as an icon
 * @param obj The table row object
 * @param field The field that identifies the boolean flag
 * @param tIcon Icon if true
 * @param fIcon Icon if false
 * @param nIcon Icon if null (optional)
 */
export const formatBooleanAsIcon = <T, >(obj: T, field: (t: T) => boolean | undefined | null, tIcon: string, fIcon: string, nIcon?: string): React.ReactElement<any> => {
    const val = field(obj);
    if (val === null)
        return nIcon ? <i className={"fa fa-" + nIcon}></i> : <span></span>;
    if (val === undefined)
        return <span></span>;
    return <i className={"fa fa-" + (val ? tIcon : fIcon)}></i>;
};

interface FormatUserFullNameOpts {
    firstNameAsInitial: boolean;
    lastNameFirst: boolean;
    includeMiddleName: boolean;
}

/**
 * Returns a formatted string representation of a user's name
 * @param user The user record
 * @param options Optional formatting options
 */
export const formatUserFullName = (user?: M.User.UserMinimal, options?: FormatUserFullNameOpts): string | React.ReactElement<any> => {
    const opts: FormatUserFullNameOpts = {
        firstNameAsInitial: false,
        lastNameFirst: false,
        includeMiddleName: true,
        ...options,
    };

    if (!user)
        return <span></span>;

    let firstName = opts.includeMiddleName
        ? Utility.joinSkipEmpty([user.firstName, user.middleName], " ")
        : user.firstName;

    if (opts.firstNameAsInitial && firstName &&  firstName.length)
        firstName = firstName.substr(0, 1).toUpperCase();

    if (opts.lastNameFirst)
        return Utility.joinSkipEmpty([user.lastName, firstName], ", ");
    return Utility.joinSkipEmpty([firstName, user.lastName], " ");
};

export const renderCaret = (direction: BT.SortOrder | null, fieldName: string) => {
    if (direction === "asc") {
        return (<span className="order dropup"><span className="caret" style={{ margin: "10px 5px" }}></span></span>);
    }
    if (direction === "desc") {
        return (<span className="order"><span className="caret" style={{ margin: "10px 5px" }}></span></span>);
    }
    return "";
};



// WEBPACK FOOTER //
// ./src/components/table/BootstrapTableHelpers.tsx